export default __webpack_public_path__ + "static/media/web_screen_meetings_de.7cc3014e.png";